import { styled } from 'styled-components';
export const AlertBannerMessage = styled.div.withConfig({
  componentId: "aui__sc-ecfq4w-0"
})(["line-height:1.5;padding:1rem;display:flex;flex-wrap:wrap;gap:0.25rem 1rem;", ""], ({
  $display
}) => $display === 'inline' && 'flex-grow: 1;');
export const AlertBannerMessageText = styled.p.withConfig({
  componentId: "aui__sc-ecfq4w-1"
})(["margin-bottom:0;margin-top:0;", ""], ({
  $display
}) => $display === 'inline' && 'width: 100%;');